import { render, staticRenderFns } from "./serviceOrder.vue?vue&type=template&id=dcaf08ce&scoped=true&"
import script from "./serviceOrder.vue?vue&type=script&lang=js&"
export * from "./serviceOrder.vue?vue&type=script&lang=js&"
import style0 from "./serviceOrder.vue?vue&type=style&index=0&id=dcaf08ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcaf08ce",
  null
  
)

export default component.exports